// Scanning and document storage run on the user's PC, even for the hosted POS.
// Keep these requests separate from the API used for sales and account data.
export const LOCAL_DOCUMENT_API = 'http://localhost:5000/api';

export async function fetchLocalDocument(path, options) {
  try {
    return await fetch(`${LOCAL_DOCUMENT_API}${path}`, options);
  } catch (error) {
    if (error.name === 'AbortError') throw error;
    throw new Error('Cannot connect to the local document service. Start the backend on this PC at http://localhost:5000 and allow local network access in your browser, then reopen documents.');
  }
}
